/**
 * Pick the experience the profile UI should treat as the "current job".
 *
 * Logic (matches the duplicated useMemo at
 * features/candidate/components/profile/header.tsx and
 * features/arbitrator/components/review/header.tsx):
 *   - Returns the entry whose `is_primary` is true, when present.
 *   - Otherwise the first entry of the list.
 *   - Otherwise `null` (missing / empty / nullish input).
 */

import type { CandidateExperience } from "@/lib/api/types";

export function selectCurrentJob(
  experiences: readonly CandidateExperience[] | null | undefined,
): CandidateExperience | null {
  if (!experiences || experiences.length === 0) return null;
  return experiences.find((e) => e.is_primary) ?? experiences[0] ?? null;
}
